import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import Swal from "sweetalert2";
import illustration from "../../assets/Icons/SettingsIllustration.svg";
import email from "../../assets/Icons/email.svg";
import company from "../../assets/Icons/company.svg";
import mobilenumber from "../../assets/Icons/mobilenumber.png";
import personal from "../../assets/Icons/personal.svg";
import lock from "../../assets/Icons/lock.svg";
import eye from "../../assets/Icons/eye.svg";
import { formatDate } from "../../helpers/DateHelpers";
import eyeClosed from "../../assets/Icons/eyeClosed.svg";
import HeaderWithBreadcrumb from "../common/HeaderWithBreadcrumb";
import { getInitial } from "../../helpers/helper";

const Settings = () => {
  const [activeTab, setActiveTab] = useState("personal");
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [lastLoginDate, setLastLoginDate] = useState("N/A");

  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showReEnter, setShowReEnter] = useState(false);

  const { setValue } = useForm({
    defaultValues: {
      companyId: "",
      companyName: "",
      userId: "",
      userProfile: "",
      userStatus: "",
      smsRate: "",
      rcsRate: "",
    },
  });

  const loggedInUserName = sessionStorage.getItem("username");

  const fetchUserData = async () => {
    setLoading(true);
    const payload = {
      username: loggedInUserName,
      userId: loggedInUserName,
      status: "",
    };

    try {
      const response = await axiosPostApi(apiList.FETCH_USER_DATA, payload);

      if (response?.status === 200 && response?.data?.data) {
        setData(response?.data?.data[0] || {});
      } else {
        if (
          response?.data?.respCode !== "01" &&
          response?.data?.data !== null
        ) {
          Swal.fire({
            title: "Failed to Fetch Data",
            text:
              response?.data?.message ||
              "No data available for the specified criteria.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const storedLoginTime = sessionStorage.getItem("loginTime");
    fetchUserData();
    if (storedLoginTime) {
      setLastLoginDate(formatDate(storedLoginTime));
    }
  }, []);

  return (
    // <HeaderWithBreadcrumb title="Purchase Credits" breadcrumb="Master" />
    <div className="p-6">
      {/* Header */}
      {/* <h1 className="text-xl font-semibold text-sky-600">My Profile</h1> */}
      <HeaderWithBreadcrumb title="My Profile" breadcrumb="Master" />

      <div className="flex gap-6 mt-16">
        {/* Left Card */}
        <div className="w-80 bg-white shadow rounded-xl p-6 relative">
          <div className="flex flex-col items-center">

          {/* Profile Icon with Green Dot for Online Status */}
          <div className="relative">
            <div className="w-28 h-28 rounded-full bg-gradient-to-tr from-orange-500 via-orange-400 to-amber-300 p-[3px] shadow-2xl">
              <div className="w-full h-full rounded-full bg-white flex items-center justify-center">
                <div className="w-[88%] h-[88%] rounded-full bg-gradient-to-br from-[#ff9a44] to-[#fc6076] flex items-center justify-center">
                  <span className="text-white text-4xl font-extrabold">
                    {getInitial(
                      data?.userProfile === "HUB"
                        ? data?.hubName
                        : data?.customerName || data?.userId
                    )}
                  </span>
                </div>
              </div>
            </div>
          
            <div className="absolute bottom-1 right-1 w-5 h-5 bg-green-500 border-2 border-white rounded-full"></div>
          </div>
            <h2 className="mt-4 text-lg font-semibold">
              {data?.userId || "N/A"}
            </h2>
            <p className="text-gray-500">{data?.userProfile === "CUSTOMER" ? "LMBP" : data?.userProfile || "N/A"}</p>

            <div className="mt-4 space-y-3 text-gray-600 text-sm w-full">
              {/* Email */}
              <div className="flex items-center gap-2">
                <img src={email} alt="email" className="w-5 h-5" />
                <span>{data?.emailId || "N/A"}</span>
              </div>

              {/* Company */}
              <div className="flex items-center gap-2">
                <img src={company} alt="company" className="w-5 h-5" />
                <span>{data?.customerName || "N/A"}</span>
              </div>

              {/* Mobile */}
              <div className="flex items-center gap-2">
                <img src={mobilenumber} alt="phone" className="w-5 h-5" />
                <span>{data?.mobileNo || "N/A"}</span>
              </div>
            </div>

            <div className="mt-6">
              <img
                src={illustration}
                alt="illustration"
                className="w-36 h-32"
              />
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="flex-1">
          {/* Tabs */}
          <div className="flex gap-4 mb-6">
            {/* Personal Information Tab */}
            <button
              onClick={() => setActiveTab("personal")}
              className="flex items-center"
            >
              <div className="bg-white border-2 border-[#145165] rounded-full w-11 h-11 flex items-center justify-center z-10">
                <img
                  src={personal}
                  alt="personal"
                  className="w-6 h-6 text-[#145165]"
                />
              </div>
              <div
                className={`-ml-3 px-4 py-2 rounded-full ${
                  activeTab === "personal"
                    ? "bg-[#ff702b] text-white"
                    : "bg-gray-100 text-gray-600"
                }`}
              >
                Personal Information
              </div>
            </button>

            {/* Change Password Tab */}
            <button
              onClick={() => setActiveTab("password")}
              className="flex items-center"
            >
              <div className="bg-white border-2 border-[#145165] rounded-full w-11 h-11 flex items-center justify-center z-10">
                <img src={lock} alt="lock" className="w-6 h-6 text-[#145165]" />
              </div>
              <div
                className={`-ml-3 px-4 py-2 rounded-full ${
                  activeTab === "password"
                    ? "bg-[#ff702b] text-white"
                    : "bg-gray-100 text-gray-600"
                }`}
              >
                Change Password
              </div>
            </button>
          </div>

          {/* Personal Info Tab */}
          {activeTab === "personal" && (
            <div className="bg-white shadow rounded-xl p-8 w-[1100px]">
              <div className="grid grid-cols-3 gap-6 mb-6">
                <div className="flex flex-col">
                  <label className="text-sm text-gray-600 mb-1">
                    {data?.userProfile === "HUB" ? "Hub Id" : "LMBP Id"}
                  </label>
                  <input
                    type="text"
                    value={data?.userCode || "N/A"}
                    readOnly
                    className="w-full rounded-md px-3 py-2 text-sm text-gray-800 cursor-not-allowed"
                    style={{
                      backgroundColor: "#E9ECEF",
                      border: "1px solid #DDDDDD",
                    }}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-sm text-gray-600 mb-1">
                    {data?.userProfile === "HUB" ? "Hub Name" : "LMBP Name"}
                  </label>
                  <input
                    type="text"
                    value={
                      data?.userProfile === "HUB"
                        ? data?.hubName
                        : data?.customerName || "N/A"
                    }
                    readOnly
                    className="w-full rounded-md px-3 py-2 text-sm text-gray-800 cursor-not-allowed"
                    style={{
                      backgroundColor: "#E9ECEF",
                      border: "1px solid #DDDDDD",
                    }}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-sm text-gray-600 mb-1">User Id</label>
                  <input
                    type="text"
                    value={data?.userId || "N/A"}
                    readOnly
                    className="w-full rounded-md px-3 py-2 text-sm text-gray-800 cursor-not-allowed"
                    style={{
                      backgroundColor: "#E9ECEF",
                      border: "1px solid #DDDDDD",
                    }}
                  />
                </div>
              </div>

              <div className="grid grid-cols-3 gap-6 mb-6">
                <div className="flex flex-col">
                  <label className="text-sm text-gray-600 mb-1">
                    User Profile
                  </label>
                  <input
                    type="text"
                    value={data?.userProfile === "CUSTOMER" ?
                           "LMBP" : data?.userProfile || "N/A"}
                    readOnly
                    className="w-full rounded-md px-3 py-2 text-sm text-gray-800 cursor-not-allowed"
                    style={{
                      backgroundColor: "#E9ECEF",
                      border: "1px solid #DDDDDD",
                    }}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-sm text-gray-600 mb-1">
                    User Status
                  </label>
                  <input
                    type="text"
                    value={data?.authStatus || "N/A"}
                    readOnly
                    className={`w-full rounded-md px-3 py-2 text-sm cursor-not-allowed font-semibold ${
                      data?.authStatus === "ACTIVE"
                        ? "text-green-600"
                        : "text-red-500"
                    }`}
                    style={{
                      backgroundColor: "#E9ECEF",
                      border: "1px solid #DDDDDD",
                    }}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-sm text-gray-600 mb-1">
                    Aadhar Number
                  </label>
                  <input
                    type="text"
                    value={data?.aadharNumber || "N/A"}
                    readOnly
                    className="w-full rounded-md px-3 py-2 text-sm text-gray-800 cursor-not-allowed"
                    style={{
                      backgroundColor: "#E9ECEF",
                      border: "1px solid #DDDDDD",
                    }}
                  />
                </div>
              </div>

              {data?.userProfile === "HUB" && (
                <>
                  <div className="grid grid-cols-3 gap-6 mb-6">
                    <div className="flex flex-col">
                      <label className="text-sm text-gray-600 mb-1">
                        GST Number
                      </label>
                      <input
                        type="text"
                        value={data?.gstNumber || "N/A"}
                        readOnly
                        className="w-full rounded-md px-3 py-2 text-sm text-gray-800 cursor-not-allowed"
                        style={{
                          backgroundColor: "#E9ECEF",
                          border: "1px solid #DDDDDD",
                        }}
                      />
                    </div>
                    <div className="flex flex-col">
                      <label className="text-sm text-gray-600 mb-1">
                        PAN No
                      </label>
                      <input
                        type="text"
                        value={data?.panNumber || "N/A"}
                        readOnly
                        className="w-full rounded-md px-3 py-2 text-sm text-gray-800 cursor-not-allowed"
                        style={{
                          backgroundColor: "#E9ECEF",
                          border: "1px solid #DDDDDD",
                        }}
                      />
                    </div>
                    <div className="flex flex-col">
                      <label className="text-sm text-gray-600 mb-1">
                        Address 1
                      </label>
                      <input
                        type="text"
                        value={data?.addr1 || "N/A"}
                        readOnly
                        className="w-full rounded-md px-3 py-2 text-sm text-gray-800 cursor-not-allowed"
                        style={{
                          backgroundColor: "#E9ECEF",
                          border: "1px solid #DDDDDD",
                        }}
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-3 gap-6 mb-6">
                    <div className="flex flex-col">
                      <label className="text-sm text-gray-600 mb-1">
                        Address 2
                      </label>
                      <input
                        type="text"
                        value={data?.addr2 || "N/A"}
                        readOnly
                        className="w-full rounded-md px-3 py-2 text-sm text-gray-800 cursor-not-allowed"
                        style={{
                          backgroundColor: "#E9ECEF",
                          border: "1px solid #DDDDDD",
                        }}
                      />
                    </div>
                    <div className="flex flex-col">
                      <label className="text-sm text-gray-600 mb-1">
                        Address 3
                      </label>
                      <input
                        type="text"
                        value={data?.addr3 || "N/A"}
                        readOnly
                        className="w-full rounded-md px-3 py-2 text-sm text-gray-800 cursor-not-allowed"
                        style={{
                          backgroundColor: "#E9ECEF",
                          border: "1px solid #DDDDDD",
                        }}
                      />
                    </div>
                    <div className="flex flex-col">
                      <label className="text-sm text-gray-600 mb-1">
                        Pin Code
                      </label>
                      <input
                        type="text"
                        value={data?.pinCode || "N/A"}
                        readOnly
                        className="w-full rounded-md px-3 py-2 text-sm text-gray-800 cursor-not-allowed"
                        style={{
                          backgroundColor: "#E9ECEF",
                          border: "1px solid #DDDDDD",
                        }}
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-3 gap-6">
                    <div className="flex flex-col">
                      <label className="text-sm text-gray-600 mb-1">
                        State
                      </label>
                      <input
                        type="text"
                        value={data?.state || "N/A"}
                        readOnly
                        className="w-full rounded-md px-3 py-2 text-sm text-gray-800 cursor-not-allowed"
                        style={{
                          backgroundColor: "#E9ECEF",
                          border: "1px solid #DDDDDD",
                        }}
                      />
                    </div>
                    <div className="flex flex-col">
                      <label className="text-sm text-gray-600 mb-1">City</label>
                      <input
                        type="text"
                        value={data?.city || "N/A"}
                        readOnly
                        className="w-full rounded-md px-3 py-2 text-sm text-gray-800 cursor-not-allowed"
                        style={{
                          backgroundColor: "#E9ECEF",
                          border: "1px solid #DDDDDD",
                        }}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          )}

          {/* Change Password Tab */}
          {activeTab === "password" && (
            <div className="bg-white shadow rounded-xl p-8 w-[1100px]">
              {/* Current Password */}
              <div className="flex flex-col mb-6 w-[293px]">
                <label className="text-sm text-gray-600 mb-1">
                  Current Password
                </label>
                <div className="flex rounded-md overflow-hidden border border-[#DDDDDD] h-[33px]">
                  <input
                    type={showCurrent ? "text" : "password"}
                    placeholder="Current Password"
                    className="flex-1 px-3 text-sm text-gray-800 focus:outline-none"
                    style={{ backgroundColor: "#FFFFFF" }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowCurrent(!showCurrent)}
                    className="flex items-center justify-center px-3 bg-[#E9ECEF]"
                    style={{ borderLeft: "1px solid #DDDDDD" }}
                  >
                    <img
                      src={showCurrent ? eye : eyeClosed}
                      alt={showCurrent ? "Hide password" : "Show password"}
                      className="w-5 h-5"
                    />
                  </button>
                </div>
              </div>

              {/* New + Re-enter Passwords */}
              <div className="flex gap-4 mb-6">
                {/* New Password */}
                <div className="flex flex-col w-[293px]">
                  {" "}
                  {/* Figma width */}
                  <label className="text-sm text-gray-600 mb-1">
                    New Password
                  </label>
                  <div className="flex rounded-md overflow-hidden border border-[#DDDDDD] h-[33px]">
                    <input
                      type={showNew ? "text" : "password"}
                      placeholder="Enter New Password"
                      className="flex-1 px-3 text-sm text-gray-800 focus:outline-none"
                      style={{ backgroundColor: "#FFFFFF" }}
                    />
                    <button
                      type="button"
                      onClick={() => setShowNew(!showNew)}
                      className="flex items-center justify-center px-3 bg-[#E9ECEF]"
                      style={{ borderLeft: "1px solid #DDDDDD" }}
                    >
                      <img
                        src={showNew ? eye : eyeClosed}
                        alt={showNew ? "Hide password" : "Show password"}
                        className="w-5 h-5"
                      />
                    </button>
                  </div>
                </div>

                {/* Re-enter New Password */}
                <div className="flex flex-col w-[293px]">
                  {" "}
                  {/* Figma width */}
                  <label className="text-sm text-gray-600 mb-1">
                    Re-enter New Password
                  </label>
                  <div className="flex rounded-md overflow-hidden border border-[#DDDDDD] h-[33px]">
                    <input
                      type={showReEnter ? "text" : "password"}
                      placeholder="Confirm Password"
                      className="flex-1 px-3 text-sm text-gray-800 focus:outline-none"
                      style={{ backgroundColor: "#FFFFFF" }}
                    />
                    <button
                      type="button"
                      onClick={() => setShowReEnter(!showReEnter)}
                      className="flex items-center justify-center px-3 bg-[#E9ECEF]"
                      style={{ borderLeft: "1px solid #DDDDDD" }}
                    >
                      <img
                        src={showNew ? eye : eyeClosed}
                        alt={showNew ? "Hide password" : "Show password"}
                        className="w-5 h-5"
                      />
                    </button>
                  </div>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex gap-4">
                <button className="px-6 py-2 bg-[#ff702b] text-white rounded-md">
                  Update
                </button>
                <button className="px-6 py-2 border-1 border-[#ff702b] text-[#ff702b] rounded-md">
                  Clear
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Settings;
